import { modulesConfig } from '@/containers/SubscriptionFormPageNew/config'

export default function modulesIsActive(key, modulesStatus, country, isExternal = false) {
  if (modulesStatus === null) {
    return false
  }
  switch (key) {
    case 'assistanceProducts':
      return modulesStatus['assistance-options'] ?? false
    case 'monConseillerPersoProducts':
      return modulesStatus['mon-conseiller-perso-options'] ?? false
    case 'carbonOffset':
      return modulesStatus['carbon-offset'] ?? false
    case 'form':
    case 'formV2':
      // except FR external users for now that are still in V1
      if (isExternal) return true
      return modulesConfig[country]?.menu?.legacyFormLink ?? true
    case 'clientCallbacks':
      return modulesConfig[country]?.menu?.callbacks ?? false
    default:
      return true
  }
}
